// extracted by mini-css-extract-plugin
export default {"noResults":"SearchNotFound_noResults__SLPlb","noResultsText":"SearchNotFound_noResultsText__m2bbe"};